module.exports = __webpack_public_path__ + "img/markerDestinationLight.8b10b4c6.svg";